/**
 * Bande CTA finale « Une faim de loup ? » — portée À L'IDENTIQUE du legacy.
 * Fond dégradé de marque (primary → dark), titre, sous-titre (délai = prep_time_min),
 * bouton blanc « Voir le menu et commander ». Branding via variables CSS.
 */
interface CtaBandProps {
  prepMin: number;
  onOrder: () => void;
}

export default function CtaBand({ prepMin, onOrder }: CtaBandProps) {
  return (
    <section
      className="text-white"
      style={{ background: 'linear-gradient(135deg, var(--brand-primary), var(--brand-dark, #1a1a1a))' }}
    >
      <div className="mx-auto max-w-7xl px-4 py-16 text-center lg:px-6 lg:py-24">
        <h2 className="display-font mb-4 text-4xl font-black lg:text-7xl">Une faim de loup ?</h2>
        <p className="mx-auto mb-8 max-w-xl text-lg opacity-90 lg:text-xl">
          Commandez en ligne en 2 minutes. Retrait au comptoir {prepMin} min plus tard.
        </p>
        <button
          onClick={onOrder}
          className="rounded-2xl bg-white px-10 py-5 text-lg font-extrabold shadow-xl transition active:scale-95"
          style={{ color: 'var(--brand-primary)' }}
        >
          Voir le menu et commander →
        </button>
      </div>
    </section>
  );
}
